import React, { useState, useEffect } from 'react';

import MultiListPopUpIT from '../atoms/MultiListPopUpIT';

function FromMoveListIT(props) {

    return (
        <div className="row form-fields">
            <div className="label col-6">
                <label></label>
            </div>
            <div className="item col-6">
                <button
                    onClick={() => { props.setShowPopUpIT(true); }}
                    className="btn btn-primary mb-2">
                    Continue <span className="bi bi-gear-fill"></span>
                </button>

                <MultiListPopUpIT
                    titleIT={props.labelIT}
                    showIT={props.showPopUpIT}
                    showsetterIT={props.setShowPopUpIT}
                    dataIT={props.dataIT}
                    datasetterIT={props.datasetterIT}
                    setLoadingIT={props.setLoadingIT}   // pass loader setter
                    setProgress={props.setProgress}     // pass progress setter
                    setTotal={props.setTotal}           // pass total setter
                />
            </div>
        </div>
    )
}

export default FromMoveListIT